// store/index.js

import Vue from 'vue'
import Vuex from 'vuex'

// imports of AJAX functions will go here
// import { bindRedeem, wxOAuth, queryUser } from '@/api'
import { bindRedeem, wxOAuth, postLevelData, postLevelData2, postJsonData, postData2Backend } from '@/api'
// import { isValidJwt, EventBus } from '@/utils'
import { EventBus } from '@/utils'

Vue.use(Vuex)

const state = {
  // single source of data
  // surveys: [],
  // currentSurvey: {},
  // user: {},
  // jwt: '',
  // openid: ''
}

const actions = {
  // asynchronous operations
  submitRedeem (context, redeem) {
    return bindRedeem(redeem)
  },
  submitLevelData (context, data, params) {
    return postLevelData(data, params)
  },
  submitLevelData2 (context, formData) {
    return postLevelData2(formData)
  },
  diniLsAdjustment (context, data) {
    return postJsonData('dini_ls_adjustment', data)
  },
  diniDataSnooping (context, data) {
    return postJsonData('dini_data_snooping', data)
  },
  postData4Download (context, data) {
    return postData2Backend(data)
  },
  startWxOAuth (/* context */) {
    return wxOAuth()
      /* .then(response => axiosGet(response.data.location).then(response => {
        context.commit('setWxOpenid', { openid: response.data })
      }).catch(error => {
        console.log('Error fetching weixin openid', error)
        EventBus.emit('failedFetchingWeixinOpenid: ', error)
      })) */
      .catch(error => {
        console.log('Error fetching weixin access token', error)
        EventBus.emit('failedFetchingWeixinAccessToken: ', error)
      })
  }
}

const mutations = {
  // isolated data mutations
  // The following are samples
  /* setSurveys (state, payload) {
    state.surveys = payload.surveys
  },
  setSurvey (state, payload) {
    const nQuestions = payload.survey.questions.length
    for (let i = 0; i < nQuestions; i++) {
      payload.survey.questions[i].choice = null
    }
    state.currentSurvey = payload.survey
  },
  setChoice (state, payload) {
    const { questionId, choice } = payload
    const nQuestions = state.currentSurvey.questions.length
    for (let i = 0; i < nQuestions; i++) {
      if (state.currentSurvey.questions[i].id === questionId) {
        state.currentSurvey.questions[i].choice = choice
        break
      }
    }
  },
  setUserData (state, payload) {
    console.log('setUserData payload = ', payload)
    state.userData = payload.userData
  },
  setJwtToken (state, payload) {
    console.log('setJwtToken payload = ', payload)
    localStorage.token = payload.jwt.token
    state.jwt = payload.jwt
  },
  setWxOpenid (state, payload) {
    console.log('setWxOpenid payload = ', payload)
    state.openid = payload.openid
  } */
  // The above are all samples
}

const getters = {
  // reusable data accessors
  // The following are samples
  /* isAuthenticated (state) {
    return isValidJwt(state.jwt.token)
  },
  isOldCustomer (state) {
    // return isValidUser(state.openid)
    return queryUser(state.openid)
      .then(response => response.exist)
      .catch(error => {
        console.log('Error querying user', error)
        EventBus.emit('failedQueryingUser', error)
      })
  } */
  // The above are all samples
}

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js